import events from "/events";
import api from "/api";
import globals from "/utils/globals";
import * as piwik from "/services/tracking/piwik";
import * as gtm from "/services/tracking/gtm";
import { hasConsent } from "/services/cookiebot";
import notify from "/utils/notify";

export let isInitialized = false;
const missedEvents = [];
const missedBIEvents = [];

export const init = () => {
  api.mickeyMouse()
    .catch(() => notify("Failed to fetch mickeyMouse"))
    .then(config => {
      initTrackingIfPermitted(config);

      if (config.is_captcha_disabled) {
        window.globals.recaptcha.activated = false;
      }

      const testCategories = config.test_categories;
      events.emit("setup:ready", config);
      events.emit("abtest:ready", testCategories || {});
    });
};

const initTrackingIfPermitted = config => {
  const isTestOrDevEnvironment = ["development", "test"].indexOf(globals.env) >= 0;
  // The event might have been fired before the event handler is registered. Therefore we have to check for already given permission, too.
  if (isTestOrDevEnvironment || hasConsent()) {
    initTracking(config);
  } else {
    events.on("cookiebot:accept", () => hasConsent() && initTracking(config));
  }
};

const initTracking = config => {
  const categories = config.test_categories;

  isInitialized = true;

  piwik.setConfig(config);
  piwik.setAbTestsCustomVariable(categories);
  piwik.push("trackPageView");

  missedEvents.forEach(e => trackEvent(...e));
  missedBIEvents.forEach(e => trackBIEvent(...e));

  gtm.push({ ab_tests: globals.abtests });

  if (window._bk_paq && !window._bk_paq.proxyOn) {
    window._bk_paq.turnProxyOn();
  }

  initDomEvents();
};

export const trackEvent = (...payload) => {
  if (isInitialized) {
    piwik.trackEvent(...payload);
  } else {
    missedEvents.push(payload);
  }
};

export const trackBIEvent = (...payload) => {
  if (isInitialized) {
    piwik.trackBIEvent(...payload);
  } else {
    missedBIEvents.push(payload);
  }
};

/* Track events on elements with data attributes:
- data-event-category
- data-event-action
- data-event-depth
- data-event-name */
const initDomEvents = () => {
  document.addEventListener("click", e => {
    const target = e.target.closest(".js-pw-link");

    if (!target) {
      return;
    }

    let {
      eventCategory: category  = "body-20170330-fallback_piwik_link",
      eventAction: action = "1-click",
      eventDepth: depth = 1,
      eventName: name
    } = target.dataset;

    const eventParams = [category, `${depth}-${action}`];

    if (name) {
      eventParams.push(name);
    }

    trackEvent(...eventParams);
  });
};
